import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';

export interface ReporteParams {
  tratamiento: string;
  tipo_reporte: string;
  start_date?: string;
  end_date?: string;
  departamento_codigo?: string;
  municipio_codigo?: string;
  entidad_codigo?: string;
  caso_id?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ReportesV2Service {
  private http = inject(HttpClient);
  private baseUrl = '/api/sinhantb/reportes/v2/';

  descargarReporte(params: ReporteParams) {
    let httpParams = new HttpParams()
      .set('tratamiento', params.tratamiento)
      .set('tipo_reporte', params.tipo_reporte);

    if (params.start_date) httpParams = httpParams.set('start_date', params.start_date);
    if (params.end_date) httpParams = httpParams.set('end_date', params.end_date);
    if (params.departamento_codigo) httpParams = httpParams.set('departamento_codigo', params.departamento_codigo);
    if (params.municipio_codigo) httpParams = httpParams.set('municipio_codigo', params.municipio_codigo);
    if (params.entidad_codigo) httpParams = httpParams.set('entidad_codigo', params.entidad_codigo);
    if (params.caso_id) httpParams = httpParams.set('caso_id', params.caso_id.toString());

    return this.http
      .get(this.baseUrl, {
        params: httpParams,
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        tap(response => {
          const blob = response.body;
          if (!blob) return;

          const contentDisposition = response.headers.get('Content-Disposition');
          let filename = `reporte_${params.tratamiento.toLowerCase()}_${params.tipo_reporte.toLowerCase()}.xlsx`;

          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match?.[1]) {
              filename = match[1];
            }
          }

          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = filename;
          anchor.click();
          window.URL.revokeObjectURL(url);
        })
      );
  }
}
